module.exports = __webpack_public_path__ + "media/images/flags/16/Libya-6ffd7aae7e4e823b0c64c4b24609cfbc.png";